import React, { useEffect, useState } from "react";
import TitleUnderlined from "../../components/TitleUnderlined";
import Breadcrumb from "../../components/Breadcrumb";
import Row from "../../components/Row";
import Column from "../../components/Column";
import Pagination from "../../components/Pagination";
import APIInterface from "../../tools/APIInterface";
import { RoutesWeb } from "../../tools/RoutesWeb";
import { DECANATO_OPTIONS } from "../../tools/decanatos";

const DecanatoLoadsView = () => {
    const token = localStorage.getItem('tokenAdmin');
    const [filters, setFilters] = useState({
        decanato: '',
        period_year: new Date().getFullYear(),
        period_quincena: '',
    });
    const [page, setPage] = useState(1);
    const [result, setResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleFilter = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value,
        });
    };

    const fetchDecanatoLoads = (filtersToUse = filters, pageToUse = page) => {
        setIsLoading(true);
        APIInterface.decanatoLoadsAdmin(token, {
            ...filtersToUse,
            page: pageToUse,
        })
        .then((response) => {
            setResult(response.data);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    useEffect(() => {
        fetchDecanatoLoads({
            decanato: '',
            period_year: new Date().getFullYear(),
            period_quincena: '',
        }, 1);
        // Carga inicial al entrar a la vista.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        setPage(1);
        fetchDecanatoLoads(filters, 1);
    };

    const handlePageChange = (nextPage) => {
        setPage(nextPage);
        fetchDecanatoLoads(filters, nextPage);
    };

    const pageTotalAttendees = result?.data?.reduce(
        (sum, load) => sum + (load.attendees_count || 0),
        0
    ) ?? 0;

    return (
        <div className="pt-5 pb-5">
            <br />
            <br />
            <Breadcrumb items={[
                { title: 'Dashboard', route: RoutesWeb.ADMIN_DASHBOARD },
                { title: 'Historial de Cargas', active: true },
            ]} />
            <TitleUnderlined>Historial de <span className="embercom_overlined">Cargas Decanatos</span></TitleUnderlined>
            <br />
            <form onSubmit={handleSearch}>
                <Row>
                    <Column className="col-md-3">
                        <label className="semibold">Decanato</label>
                        <select className="form-control" name="decanato" value={filters.decanato} onChange={handleFilter}>
                            <option value="">Todos</option>
                            {DECANATO_OPTIONS.map((decanato) => (
                                <option key={decanato} value={decanato}>{decanato}</option>
                            ))}
                        </select>
                    </Column>
                    <Column className="col-md-3">
                        <label className="semibold">Año</label>
                        <input className="form-control" type="number" name="period_year" value={filters.period_year} onChange={handleFilter} />
                    </Column>
                    <Column className="col-md-3">
                        <label className="semibold">Quincena</label>
                        <select className="form-control" name="period_quincena" value={filters.period_quincena} onChange={handleFilter}>
                            <option value="">Todas</option>
                            <option value="1">Primera</option>
                            <option value="2">Segunda</option>
                        </select>
                    </Column>
                    <Column className="col-md-3 d-flex align-items-end">
                        <button className="btn btn-main w-100" type="submit">{isLoading ? 'Consultando...' : 'Consultar'}</button>
                    </Column>
                </Row>
            </form>
            <br />
            {result && (
                <p className="mb-2">
                    <small className="text-muted">
                        Inscritos en esta página: <b>{pageTotalAttendees}</b>
                        {result.total != null && (
                            <> · Cargas totales: <b>{result.total}</b></>
                        )}
                    </small>
                </p>
            )}
            <table className="table">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Decanato</th>
                        <th>Quincena</th>
                        <th>Lider</th>
                        <th>Inscritos</th>
                        <th>Boletos</th>
                        <th>Adjunto</th>
                    </tr>
                </thead>
                <tbody>
                    {result && result.data && result.data.length > 0 ? result.data.map((load) => (
                        <tr key={load.id}>
                            <td>{new Date(load.registered_at).toLocaleString()}</td>
                            <td>{load.decanato}</td>
                            <td>{load.period_year} - {load.period_quincena}</td>
                            <td>{load.user ? load.user.name : '-'}</td>
                            <td>{load.attendees_count}</td>
                            <td>
                                <a
                                    href={`${process.env.REACT_APP_API_URL}/boletos/${load.order_id}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Descargar PDF
                                </a>
                            </td>
                            <td>
                                <a href={`${load.attachment_url}`} target="_blank" rel="noreferrer">Ver archivo</a>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan="7">{isLoading ? 'Cargando resultados...' : 'Sin resultados'}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <Pagination
                currentPage={result?.current_page ?? page}
                lastPage={result?.last_page ?? 1}
                total={result?.total ?? 0}
                from={result?.from}
                to={result?.to}
                disabled={isLoading}
                onPageChange={handlePageChange}
            />
        </div>
    );
};

export default DecanatoLoadsView;
